<template>  
  <v-card>
    <v-card
      dark
      flat
    >      
      <v-img src="https://cdn.vuetifyjs.com/images/cards/forest.jpg" :aspect-ratio="3" gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)">
        <v-container fill-height>
          <v-layout align-center>
            <strong class="display-4 font-weight-regular mr-4">{{$moment().format('DD')}}</strong>
            <v-layout column justify-end>
              <div class="headline font-weight-light">{{$moment().format('dddd')}}</div>
              <div class="text-uppercase font-weight-light">{{$moment().format('MMMM YYYY')}}</div>
              <div class="text-uppercase font-weight-light display-1">{{jam}}</div>
            </v-layout>
          </v-layout>
        </v-container>
      </v-img>
    </v-card>
    <v-timeline
      align-top
      dense
      class="pb-3"
    >
      <template v-for="(item,i) in items">
        <v-timeline-item
          :color="item.childs.color ? item.childs.color : 'blue'"
          small :key="i"
        >
          <v-layout pt-3>
            <v-flex xs3>
              <strong>{{item.childs.time}}</strong>
            </v-flex>
            <v-flex>
              <strong>{{item.name}}</strong>
              <div class="caption">{{item.childs.description}}</div>
            </v-flex>
          </v-layout>
        </v-timeline-item>  
      </template>      
    </v-timeline>             
  </v-card>  
</template>
<script>
import Model from '@/models/dashboard'
const  model = new Model();
export default {
  name : 'timeline',  
  components: {
  },
  props :{
    drawer : {
      type: Boolean,
      default: false,
    },
  },
  data:()=>({
    drawerLocal : false,
    items : [],
    jam : null,
  }),
  created(){
     this.$emit('update:drawer', JSON.parse(this.drawer))
  },
  mounted(){
    setInterval(()=>{this.jam = this.$moment().format('HH:mm:ss');},1000);
    model.settings({key:'timeline'}).then(res=>{
      this.items = res.value;      
    });
  },
  watch: {            
    drawer(newVal){this.drawerLocal = newVal; console.log(newVal);
    this.$emit('update:drawer', JSON.parse(this.drawer))},
  }
};
</script>
<style>
  .v-timeline-item{
    padding-bottom:7px;
  }
</style>


